import { faBan } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FC } from "react";

import styles from "./rotatingCircleLoadingIndicator.module.scss";

type TRotatingCircleLoadingIndicatorProps = {
    text?: string,
    onCancel?: () => void
}

export const RotatingCircleLoadingIndicator: FC<TRotatingCircleLoadingIndicatorProps> = ({onCancel, text} : TRotatingCircleLoadingIndicatorProps) => {
    return (
        <div className={styles.rotatingCircleLoadingContainer}>
            <div className={styles.rotatingCircleLoadingIndicator}></div>
            { onCancel ? <div className={styles.cancelSearchButton} onClick={onCancel}><FontAwesomeIcon icon={faBan} /> Cancel</div> : null}
            { text ? <span>{text}</span> : null}
        </div>
    );
};